import axios from 'axios'
import { roleAnalysis } from '../common/common'

// 从localStorage中获取token
function getLocalToken() {
    const token = window.localStorage.getItem('token')
    return token
}

// 创建一个axios实例
const instance = axios.create({
    timeout: 300000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + getLocalToken() // headers塞token
    }
})

// 是否正在刷新的标记
let isRefreshing = false

instance.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    const userInfo = roleAnalysis(token);
    if (userInfo === null) {//过期了
        if (isRefreshing === false) {
            isRefreshing = true;
            const refresh_token = localStorage.getItem('refreshToken');
            instance.defaults.headers['Authorization'] = 'Bearer ' + refresh_token
            instance.get('/api/v1/users/token/current').then(res => {
                isRefreshing = false
                const token = res.data.data.access_token;
                instance.defaults.headers['Authorization'] = 'Bearer ' + token;
                // localStorage.setItem('token', token);
            }).catch(res => {
                console.error('refresh token error: ', res)
                window.location.href = '/';
            })
        }
    }
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});
instance.interceptors.response.use(
    res => {
        return res;
    },
    err => {
        if (err.response) {
            const errCode = err.response.status;
            if (errCode === 400) {
                console.log("400!!!")
            }
        }
        return Promise.reject(err);
    }
);

export default instance;